import type { ToolStatusTone } from '@/utils/toolStatus';

import type { ToolCodeLabelKey } from './StatusCodeBadge.types';

export const TONE_CLASS: Record<ToolStatusTone, string> = {
	success: 'border-green-200 bg-green-50 text-success',
	warning: 'border-yellow-200 bg-yellow-50 text-warning',
	error: 'border-red-200 bg-red-50 text-error',
	unknown: 'border-subtle bg-grey-25 text-subtle',
};

/** Left rail of the tool call card — the colour you can scan down the margin. */
export const TONE_BAR_CLASS: Record<ToolStatusTone, string> = {
	success: 'bg-green-500',
	warning: 'bg-yellow-500',
	error: 'bg-red-500',
	unknown: 'bg-grey-100',
};

export const TONE_LABEL_KEY: Record<ToolStatusTone, ToolCodeLabelKey> = {
	success: 'TOOL_CODE_OK',
	warning: 'TOOL_CODE_EMPTY',
	error: 'TOOL_CODE_FAILED',
	unknown: 'TOOL_CODE_UNKNOWN',
};
